import React from 'react';
import { Link } from 'react-router-dom';
import FormatNumber from 'bukku/components/FormatNumber';
import queryString from 'query-string';

// Columns Functions
export const ColumnsHelper = {
    getColClassName: columnType => {
        switch (columnType) {
            case 'heading':
                return 'report-heading-col';
            case 'category_total':
                return 'report-category-total-col';
            case 'type_total':
                return 'report-type-total-col';
            case 'spacer':
                return 'report-spacer-col';
            default:
                return 'report-normal-col';
        }
    },

    getFirstColSpan: columnType => {
        switch (columnType) {
            case 'heading':
            case 'spacer':
                return 2;
            case 'category_total':
            case 'type_total':
                return 2;
            default:
                return 1;
        }
    },

    getSecondColSpan: columnType => {
        switch (columnType) {
            case 'heading':
            case 'category_total':
            case 'type_total':
            case 'spacer':
                return 0;
            default:
                return 1;
        }
    },

    getOtherColSpan: columnType => {
        switch (columnType) {
            default:
                return 1;
        }
    },
};

// Render Cell Functions
export const CellRendererHelper = {
    getUrl: (account, filterState) => {
        const {
            date_preset,
            date_range,
            tag_ids,
            include_unrealised_gain_loss,
        } = filterState;

        const params = {
            account_ids: [account.id],
            date_from: date_range[0].format("YYYY-MM-DD"),
            date_to: date_range[1].format("YYYY-MM-DD"),
            date_preset,
            tag_ids,
            include_unrealised_gain_loss,
        };

        const paramString = queryString.stringify(params, { arrayFormat: 'bracket' });
        return `/reports/general-ledger?${paramString}`;
    },

    renderNameCell: (text, record, filterState) => {
        let text2;
        if (!record.columnType && record.system_type !== 'current_earnings' && typeof record.id === 'number')
            text2 = <Link to={CellRendererHelper.getUrl(record, filterState)}>{text}</Link>;
        else
            text2 = text;

        return text2;
    },

    renderCodeCell: (text, record, filterState, showCode) => {
        let text2;
        if (!showCode && !record.columnType)
            return null;
        if (!record.columnType && record.system_type !== 'current_earnings' && typeof record.id === 'number')
            text2 = <Link to={CellRendererHelper.getUrl(record, filterState)}>{text}</Link>;
        else
            text2 = text;

        return text2;
    },

    renderBalance: (text, record, currencySymbol) => {
        switch (record.columnType) {
            case 'spacer':
            case 'heading':
                return null;
            default: {
                const extendedClassName = record.children ? ' parent' : '';
                return (
                    <div className={`amount-container${extendedClassName}`}>
                        <div className="currency">{currencySymbol}</div>
                        <div className="value" style={{ width: 120 }}>
                            <FormatNumber amount={text} />
                        </div>
                    </div>
                );
            }
        }
    },

    renderBalanceCell: (item, idx, currencySymbol) => ({
        title: (
            <div className="date-title-container">
                {item}
            </div>),
        key: `balance${idx}`,
        dataIndex: `balance${idx}`,
        align: 'right',
        width: 180,
        onCell: record => ({
            colSpan: ColumnsHelper.getOtherColSpan(record.columnType),
            className: ColumnsHelper.getColClassName(record.columnType),
        }),
        render: (text, record) => CellRendererHelper.renderBalance(text, record, currencySymbol),
    }),

    renderPercentage: (idx, text, record) => {
        switch (record.columnType) {
            case 'spacer':
            case 'heading':
                return null;
            default: {
                return <FormatNumber amount={text} />;
            }
        }
    },

    renderPercentageCell: idx => ({
        title: '%',
        key: `percentage${idx}`,
        dataIndex: `percentage${idx}`,
        align: 'right',
        width: 50,
        onCell: record => ({
            colSpan: 1,
            className: `report-percentage-col ${record.children ? 'parent' : ''}`,
        }),
        render: (text, record) => CellRendererHelper.renderPercentage(idx, text, record),
    }),

};
